module.exports = __webpack_public_path__ + "static/img/sf.d28a682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sf.png
// module id = Wdbu
// module chunks = 1